// extracted by mini-css-extract-plugin
export var body = "_de-0";
export var sectionHeader = "_de-4";
export var shortcutColumns = "_de-2";
export var shortcutList = "_de-1";
export var shortcutSection = "_de-3";